/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable array-callback-return */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { SpinnerDotted } from 'spinners-react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableContext } from '../../contexts/tableContext';
import TextInput from '../../components/TextField/TextField';
import { Entry } from '../../redux/entrySlice';
import { CapitalizeFirstLetter } from '../../utilityFunctions/utilsFunctions';
import styles from './edit.module.scss';
import { getCookies, setCookies } from '../../hooks/useCookies';

const EditRoles = React.memo(() => {
  let RoleId;
  const [submiting, setSubmitting] = useState(false);
  const params = useParams();
  const {
    dashboardStyle,
    setDashboardHeader,
    bodyStyle,
    formthemeStyle,
    bodyheader,
    errormsgStyle,
    permissionboxStyle,
  } = useContext(TableContext);
  const [permissions, setPermisisons] = useState();
  // eslint-disable-next-line no-unused-vars
  const [defaultSelectall, setDefaultSelectall] = useState([]);
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [role, setRole] = useState([]);
  const [defaultSelectAllValues, setDefaultSelectAllValues] = useState([]);
  const permissionsItems = ['create', 'edit', 'view', 'delete'];
  const viewOnly = 'view';
  useEffect(() => {
    window.scrollTo(0, 0);
    setDashboardHeader('Edit Role Details');
    setLoading(true);
    RoleId = params.roleId;
    const actionData = {};
    actionData.actionUrl = `roles/${RoleId}`;
    actionData.actionMethod = 'get';
    dispatch(Entry(actionData)).then((resp) => {
      const permissionsObj = {};
      resp.payload.data.response.result.permissions.forEach((permission) => {
        const clonedObj = JSON.parse(JSON.stringify(permission));
        delete clonedObj.section;
        const arr = [];
        Object.keys(clonedObj).forEach((key) => {
          const newObj = {};
          newObj[key] = clonedObj[key];
          arr.push(newObj);
        });
        permissionsObj[permission.section] = arr;
      });
      const perm = resp.payload.data.response.result.permissions;
      const mod = resp.payload.data.response.modules;
      const permi = [];
      mod.forEach((module) => {
        let isAvailable = false;
        perm.forEach((item) => {
          const itemName = item.section;
          if (module.modules === itemName.toLowerCase()) {
            if (module.subMenu) {
              const subpermi = [];
              module.subMenu.forEach((subModule) => {
                let isAvailableSub = false;
                item.submenu?.forEach((element) => {
                  const subitem = element.section;
                  if (subModule.modules === subitem.toLowerCase()) {
                    subpermi.push(element);
                    isAvailableSub = true;
                  }
                });
                if (!isAvailableSub) {
                  subpermi.push({
                    create: false,
                    edit: false,
                    section: subModule.modules.toLowerCase(),
                    view: false,
                    delete: false,
                  });
                }
              });
              permi.push({
                section: item.section,
                view: item.view,
                submenu: subpermi,
              });
            } else if (module.modules === 'dashboard') permi.push(item);
            else if (item.submenu) {
              permi.push({
                section: item.section,
                view: item.view,
                create: false,
                edit: false,
                delete: false,
              });
            } else permi.push(item);
            isAvailable = true;
          }
        });
        if (!isAvailable) {
          if (module.subMenu) {
            const subpermi = [];
            module.subMenu.forEach((subMenuItem) => {
              subpermi.push({
                create: false,
                edit: false,
                section: subMenuItem.modules.toLowerCase(),
                view: false,
                delete: false,
              });
            });
            permi.push({
              section: module.modules.toLowerCase(),
              view: false,
              submenu: subpermi,
            });
          } else {
            permi.push({
              create: false,
              edit: false,
              section: module.modules.toLowerCase(),
              view: false,
              delete: false,
            });
          }
        }
      });
      const selectAllDefault = [];
      permi.forEach((element) => {
        if (element.submenu) {
          element.submenu.forEach((subModule) => {
            if (!subModule.create || !subModule.delete || !subModule.edit || !subModule.view)
              if (!selectAllDefault.includes(`select-all-${element.section}`))
                selectAllDefault.push(`select-all-${element.section}`);
          });
          if (!element.view)
            if (!selectAllDefault.includes(`select-all-${element.section}`))
              selectAllDefault.push(`select-all-${element.section}`);
        } else if (element.section === 'dashboard') {
          if (!element.view)
            if (!selectAllDefault.includes(`select-all-${element.section}`))
              selectAllDefault.push(`select-all-${element.section}`);
        } else if (!element.create || !element.delete || !element.edit || !element.view)
          if (!selectAllDefault.includes(`select-all-${element.section}`))
            selectAllDefault.push(`select-all-${element.section}`);
      });
      if (selectAllDefault.length > 0) selectAllDefault.push(`select-all`);
      setDefaultSelectAllValues(selectAllDefault);
      setPermisisons(permi);
      setRole(resp.payload.data.response.result);
      reset(resp.payload.data.response.result);
      setLoading(false);
    });
  }, []);
  function onSubmitdata(data) {
    setSubmitting(true);
    RoleId = params.roleId;
    const apiData = {
      name: data.name,
      permissions,
    };
    data.actionUrl = `roles/${RoleId}`;
    data.actionMethod = 'patch';
    data.apiData = apiData;
    // console.log(data);
    setError(null);
    dispatch(Entry(data)).then((resp) => {
      setSubmitting(false);
      if (resp.payload.code === 200) {
        const currentUserRole = getCookies('USERROLE');
        if (resp.payload.role.name.toLowerCase() === currentUserRole.toLowerCase()) {
          setCookies('USERPERMISSION', resp.payload.role.permissions);
          // setCookies('USERMENU', resp.payload.userMenu.userMenu);
        }
        navigate(-1);
      } else if (
        resp.payload.code === 401 ||
        resp.payload.code === 400 ||
        resp.payload.code === 500
      ) {
        setError(resp.payload.message);
      } else {
        setError('Something went wrong!');
      }
    });
  }
  // const [checkedState, setCheckedState] = useState([]);

  const handleOnChange = (e, permission, section, subSection, isSubmenu = false) => {
    if (e.target.value === 'select-all') {
      permissions.forEach((element, index) => {
        document.getElementById(`select-all-${element.section}`).checked = e.target.checked;
        if (element.submenu) {
          permissions[index][`${viewOnly}`] = e.target.checked;
          document.getElementById(`custom-checkbox-${element.section}-${viewOnly}`).checked =
            e.target.checked;
          element.submenu.forEach((subItem, subIndex) => {
            permissionsItems.forEach((permissionItem) => {
              permissions[index].submenu[subIndex][`${permissionItem}`] = e.target.checked;
              document.getElementById(
                `custom-checkbox-${element.section}-${subItem.section}-${permissionItem}`
              ).checked = e.target.checked;
            });
          });
        } else if (element.section === 'dashboard') {
          permissions[index][`${viewOnly}`] = e.target.checked;
          document.getElementById(`custom-checkbox-${element.section}-${viewOnly}`).checked =
            e.target.checked;
        } else
          permissionsItems.forEach((permissionItem) => {
            permissions[index][`${permissionItem}`] = e.target.checked;
            document.getElementById(
              `custom-checkbox-${element.section}-${permissionItem}`
            ).checked = e.target.checked;
          });
        setPermisisons(permissions);
      });
    } else if (e.target.value === `select-all-${section}`) {
      permissions.forEach((element, index) => {
        if (element.section === section) {
          if (element.submenu) {
            permissions[index][`${viewOnly}`] = e.target.checked;
            document.getElementById(`custom-checkbox-${section}-${viewOnly}`).checked =
              e.target.checked;
            element.submenu.forEach((subItem, subIndex) => {
              permissionsItems.forEach((permissionItem) => {
                permissions[index].submenu[subIndex][`${permissionItem}`] = e.target.checked;
                document.getElementById(
                  `custom-checkbox-${section}-${subItem.section}-${permissionItem}`
                ).checked = e.target.checked;
              });
            });
          } else if (element.section === 'dashboard') {
            permissions[index][`${viewOnly}`] = e.target.checked;
            document.getElementById(`custom-checkbox-${element.section}-${viewOnly}`).checked =
              e.target.checked;
          } else
            permissionsItems.forEach((permissionItem) => {
              permissions[index][`${permissionItem}`] = e.target.checked;
              document.getElementById(`custom-checkbox-${section}-${permissionItem}`).checked =
                e.target.checked;
            });
          if (e.target.checked === false)
            document.getElementById('select-all').checked = e.target.checked;
          else {
            const falseFlag = [];
            permissions.forEach((sectionItems) => {
              if (document.getElementById(`select-all-${sectionItems.section}`).checked === false) {
                document.getElementById('select-all').checked = false;
                falseFlag.push(`select-all-${sectionItems.section}`);
              }
            });
            if (falseFlag.length === 0)
              document.getElementById('select-all').checked = e.target.checked;
          }

          setPermisisons(permissions);
        }
      });
    } else {
      permissions.forEach((element, index) => {
        if (element.section === section) {
          if (isSubmenu) {
            element.submenu.forEach((subItem, subIndex) => {
              if (subItem.section === subSection)
                permissions[index].submenu[subIndex][`${permission}`] = e.target.checked;
            });
          } else {
            permissions[index][`${permission}`] = e.target.checked;
          }
          if (e.target.checked === false) {
            document.getElementById('select-all').checked = e.target.checked;
            document.getElementById(`select-all-${element.section}`).checked = e.target.checked;
          } else {
            const falseFlag = [];
            permissions.forEach((sectionItems, sectionIndex) => {
              if (sectionItems.submenu) {
                const falsesubFlag = [];
                if (!permissions[sectionIndex][`${viewOnly}`])
                  falsesubFlag.push(permissions[sectionIndex][`${viewOnly}`]);
                sectionItems.submenu.forEach((subItem) => {
                  permissionsItems.forEach((permissionItem) => {
                    if (
                      !document.getElementById(
                        `custom-checkbox-${sectionItems.section}-${subItem.section}-${permissionItem}`
                      ).checked
                    )
                      falsesubFlag.push(
                        `custom-checkbox-${sectionItems.section}-${subItem.section}-${permissionItem}`
                      );
                  });
                });
                if (falsesubFlag.length === 0)
                  document.getElementById(`select-all-${sectionItems.section}`).checked =
                    e.target.checked;
              } else if (sectionItems.section === 'dashboard') {
                if (permissions[sectionIndex][`${viewOnly}`])
                  document.getElementById(`select-all-${sectionItems.section}`).checked =
                    e.target.checked;
              } else {
                const falsesubFlag = [];
                permissionsItems.forEach((permissionItem) => {
                  if (
                    !document.getElementById(
                      `custom-checkbox-${sectionItems.section}-${permissionItem}`
                    ).checked
                  )
                    falsesubFlag.push(`custom-checkbox-${sectionItems.section}-${permissionItem}`);
                });
                if (falsesubFlag.length === 0)
                  document.getElementById(`select-all-${sectionItems.section}`).checked =
                    e.target.checked;
              }
              if (document.getElementById(`select-all-${sectionItems.section}`).checked === false) {
                document.getElementById('select-all').checked = false;
                falseFlag.push(`select-all-${sectionItems.section}`);
              }
            });
            if (falseFlag.length === 0)
              document.getElementById('select-all').checked = e.target.checked;
          }
          setPermisisons(permissions);
        }
      });
    }
  };

  return (
    <div className={styles[bodyStyle]}>
      <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
        <form onSubmit={handleSubmit(onSubmitdata)}>
          <div className="form_head">
            <div
              value="Back"
              onClick={() => {
                navigate(-1);
              }}
              className={`${styles.arrowback} backBtn`}
            >
              <svg
                className="mr-1"
                width="17"
                height="14"
                viewBox="0 0 17 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 6.00003H3.64L7.27 1.64003C7.43974 1.43581 7.5214 1.17253 7.49702 0.908108C7.47264 0.643682 7.34422 0.39977 7.14 0.230032C6.93578 0.060293 6.6725 -0.0213689 6.40808 0.0030108C6.14365 0.0273905 5.89974 0.155815 5.73 0.360032L0.73 6.36003C0.696361 6.40776 0.666279 6.45789 0.64 6.51003C0.64 6.56003 0.64 6.59003 0.57 6.64003C0.524674 6.75469 0.500941 6.87674 0.5 7.00003C0.500941 7.12332 0.524674 7.24537 0.57 7.36003C0.57 7.41003 0.57 7.44003 0.64 7.49003C0.666279 7.54217 0.696361 7.59231 0.73 7.64003L5.73 13.64C5.82402 13.7529 5.94176 13.8437 6.07485 13.9059C6.20793 13.9681 6.35309 14.0003 6.5 14C6.73365 14.0005 6.96009 13.9191 7.14 13.77C7.24126 13.6861 7.32496 13.583 7.38631 13.4666C7.44766 13.3503 7.48546 13.223 7.49754 13.092C7.50961 12.961 7.49573 12.829 7.45669 12.7034C7.41764 12.5777 7.3542 12.4611 7.27 12.36L3.64 8.00003H15.5C15.7652 8.00003 16.0196 7.89467 16.2071 7.70714C16.3946 7.5196 16.5 7.26525 16.5 7.00003C16.5 6.73482 16.3946 6.48046 16.2071 6.29292C16.0196 6.10539 15.7652 6.00003 15.5 6.00003Z"
                  fill=""
                />
              </svg>
              Back
            </div>
            <div>
              <span className="sub_btn">
                <input
                  className={styles.formbtn}
                  type="submit"
                  disabled={submiting}
                  value={submiting ? 'Please wait..' : 'Submit'}
                />
              </span>
            </div>
          </div>
          {loading ? (
            <SpinnerDotted style={{ marginLeft: '250px', marginTop: '50px', color: '#39979d' }} />
          ) : (
            <div className={`${styles[formthemeStyle]} addRole_container`} id={styles.addform}>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-4 col-sm-4 add_input">
                    {role && (
                      <TextInput
                        className={styles.inputbox}
                        classNamedark={styles.inputbox1}
                        labelstyle={styles.formlabel}
                        label="Role Name"
                        fieldName="name"
                        placeHolder="Enter Role Name"
                        register={register}
                        errors={errors}
                        isRequired
                        mandatory
                      />
                    )}
                  </div>
                </div>
                <div>
                  <input
                    defaultChecked={!defaultSelectAllValues.includes('select-all')}
                    type="checkbox"
                    id="select-all"
                    name="select-all"
                    value="select-all"
                    onChange={(e) => handleOnChange(e, 'all', 'all')}
                  />
                  <label htmlFor="select-all" className={styles.selectlabel}>
                    Select all
                  </label>
                </div>
                <br />
                {permissions &&
                  permissions.map((item) => (
                    <div className="row">
                      <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className={styles[permissionboxStyle]} id={styles.permissionbox}>
                          <div className={styles.permission_title}>
                            <input
                              defaultChecked={
                                !defaultSelectAllValues.includes(`select-all-${item.section}`)
                              }
                              type="checkbox"
                              id={`select-all-${item.section}`}
                              name={`select-all-${item.section}`}
                              value={`select-all-${item.section}`}
                              onChange={(e) => handleOnChange(e, 'all', item.section)}
                            />
                            <h5
                              htmlFor={`select-all-${item.section}`}
                              className={styles[bodyheader]}
                              id={styles.addheading}
                            >
                              {CapitalizeFirstLetter(item.section)}
                            </h5>
                          </div>
                          {item.section === 'dashboard' || item.submenu ? (
                            <ul>
                              <li>
                                <input
                                  defaultChecked={item[`${viewOnly}`]}
                                  type="checkbox"
                                  id={`custom-checkbox-${item.section}-${viewOnly}`}
                                  name={viewOnly}
                                  value={viewOnly}
                                  onChange={(e) => handleOnChange(e, viewOnly, item.section)}
                                />
                                <label
                                  htmlFor={`custom-checkbox-${item.section}-${viewOnly}`}
                                  className={styles.selectlabel}
                                >
                                  {viewOnly}
                                </label>
                              </li>
                            </ul>
                          ) : (
                            <ul>
                              {permissionsItems.map((name) => (
                                <li>
                                  <input
                                    defaultChecked={item[`${name}`]}
                                    type="checkbox"
                                    id={`custom-checkbox-${item.section}-${name}`}
                                    name={name}
                                    value={name}
                                    onChange={(e) => handleOnChange(e, name, item.section)}
                                  />
                                  <label
                                    htmlFor={`custom-checkbox-${item.section}-${name}`}
                                    className={styles.selectlabel}
                                  >
                                    {name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          )}
                          {item.submenu ? (
                            <div className="mt-3 mb-3">
                              <h5 className={styles[bodyheader]} id={styles.addheading}>
                                {CapitalizeFirstLetter('submenu')}
                              </h5>
                            </div>
                          ) : (
                            ''
                          )}

                          {item.submenu
                            ? item.submenu.map((subvalue) => (
                                <div className="row">
                                  <div className="col-md-12 col-sm-12">
                                    <div
                                      className={styles[permissionboxStyle]}
                                      id={styles.permissionbox}
                                    >
                                      <h5 className={styles[bodyheader]} id={styles.addheading}>
                                        {CapitalizeFirstLetter(subvalue.section)}
                                      </h5>
                                      <ul>
                                        {permissionsItems.map((name) => (
                                          <li>
                                            <input
                                              defaultChecked={subvalue[`${name}`]}
                                              type="checkbox"
                                              id={`custom-checkbox-${item.section}-${subvalue.section}-${name}`}
                                              name={name}
                                              value={name}
                                              onChange={(e) =>
                                                handleOnChange(
                                                  e,
                                                  name,
                                                  item.section,
                                                  subvalue.section,
                                                  true
                                                )
                                              }
                                            />
                                            <label
                                              htmlFor={`custom-checkbox-${item.section}-${subvalue.section}-${name}`}
                                              className={styles.selectlabel}
                                            >
                                              {name}
                                            </label>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              ))
                            : ''}
                        </div>
                      </div>
                    </div>
                  ))}
                {error && <h6 className={styles[errormsgStyle]}>{error}</h6>}
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
});

export default EditRoles;
